import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bfec4304"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-shell" }
const _hoisted_2 = { class: "masthead" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "brand-mark",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("i"),
  /*#__PURE__*/_createElementVNode("i"),
  /*#__PURE__*/_createElementVNode("i")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h1", null, "海浪之歌")
], -1))
const _hoisted_5 = { class: "masthead-actions" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { "aria-hidden": "true" }, "←", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "返回岛民岛", -1))
const _hoisted_8 = {
  key: 1,
  class: "collect-panel",
  "aria-live": "polite"
}
const _hoisted_9 = { class: "collect-copy" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "eyebrow" }, "ISLAND FORAGING", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "去岛上转转", -1))
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("今天还可以搜集 ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" 次，找到的东西会放进你的背包。")
const _hoisted_16 = { key: 2 }
const _hoisted_17 = {
  key: 0,
  class: "collect-result"
}
const _hoisted_18 = {
  key: 1,
  class: "collect-error"
}
const _hoisted_19 = ["disabled"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("small", null, "TONIGHT'S MENU"),
  /*#__PURE__*/_createTextVNode("今夜酒单")
], -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, "↑", -1))
const _hoisted_22 = { class: "prototype-grid" }
const _hoisted_23 = { class: "stage-column" }
const _hoisted_24 = { class: "speaker" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "portrait-dot" }, null, -1))
const _hoisted_26 = { class: "venue-state" }
const _hoisted_27 = {
  key: 0,
  class: "typing-cursor",
  "aria-hidden": "true"
}
const _hoisted_28 = {
  class: "mobile-player-actions",
  "aria-label": "玩家操作"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "出门搜集", -1))
const _hoisted_30 = { key: 0 }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "物品与行囊", -1))
const _hoisted_32 = {
  key: 0,
  class: "drink-archive"
}
const _hoisted_33 = { class: "archive-heading" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "eyebrow" }, "TONIGHT'S DRINK", -1))
const _hoisted_35 = { key: 0 }
const _hoisted_36 = {
  key: 0,
  class: "loading-lines"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))
const _hoisted_40 = [
  _hoisted_37,
  _hoisted_38,
  _hoisted_39
]
const _hoisted_41 = { class: "archive-grid" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "风味", -1))
const _hoisted_43 = { class: "flavor-tags" }
const _hoisted_44 = { key: 0 }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "口感 / 质地", -1))
const _hoisted_46 = { class: "source-strip" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "原料从哪里来", -1))
const _hoisted_48 = { key: 0 }
const _hoisted_49 = {
  key: 0,
  class: "drink-extras"
}
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "本杯加料", -1))
const _hoisted_51 = { class: "panel-heading" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "eyebrow" }, "TONIGHT'S MENU"),
  /*#__PURE__*/_createElementVNode("h2", null, "今夜酒单")
], -1))
const _hoisted_53 = { class: "panel-actions" }
const _hoisted_54 = ["disabled"]
const _hoisted_55 = {
  key: 0,
  class: "api-error"
}
const _hoisted_56 = {
  key: 1,
  class: "loading-lines"
}
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))
const _hoisted_60 = [
  _hoisted_57,
  _hoisted_58,
  _hoisted_59
]
const _hoisted_61 = {
  key: 2,
  class: "recipe-list"
}
const _hoisted_62 = ["onClick"]
const _hoisted_63 = { class: "recipe-copy" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "card-arrow" }, "›", -1))
const _hoisted_65 = {
  key: 3,
  class: "selected-note"
}
const _hoisted_66 = { class: "note-topline" }
const _hoisted_67 = { class: "technique" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "手法", -1))
const _hoisted_69 = { class: "custom-order" }
const _hoisted_70 = { class: "custom-heading" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("small", null, "CUSTOM MIX"),
  /*#__PURE__*/_createElementVNode("strong", null, "给这杯加点东西")
], -1))
const _hoisted_72 = {
  key: 0,
  class: "extra-picker"
}
const _hoisted_73 = { class: "extra-name" }
const _hoisted_74 = { class: "source-choice" }
const _hoisted_75 = ["disabled", "onClick"]
const _hoisted_76 = ["disabled", "onClick"]
const _hoisted_77 = {
  key: 0,
  class: "extra-quantity"
}
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "加入量", -1))
const _hoisted_79 = ["value", "max", "onInput"]
const _hoisted_80 = ["onClick"]
const _hoisted_81 = {
  key: 1,
  class: "extra-chips"
}
const _hoisted_82 = ["onClick"]
const _hoisted_83 = /*#__PURE__*/_createTextVNode(" × ")
const _hoisted_84 = { key: 2 }
const _hoisted_85 = { class: "action-area" }
const _hoisted_86 = ["disabled"]

import { computed, onBeforeUnmount, onMounted, ref, watch } from 'vue'
import PixelBarStage from '../features/bar/PixelBarStage.vue'
import BarSuppliesDrawer from '../features/bar/BarSuppliesDrawer.vue'
import {
  BarApiError, collectBarItem, createOrderSocket, fetchBackpack, fetchCollectStatus, fetchDrink,
  fetchIngredients, fetchIslandEnvironment, fetchMenu, fetchTrace, submitBackpackItem,
} from '../features/bar/api'
import type {
  Appearance, BackpackItem, BarEvent, CollectResult, CollectStatus, ExtraIngredient, IngredientCatalogItem,
  IslandEnvironment, Recipe,
} from '../features/bar/types'
import store from '../store'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const recipes = ref<Recipe[]>([])
const selectedId = ref(2)
const loading = ref(true)
const error = ref('')
// localStorage may be updated from the local login page or DevTools after the
// Vuex store was created. Prefer the freshest persisted value for bar requests.
const token = computed(() => String(localStorage.getItem('token') || store.getters.getAuthToken || '').trim())
const cue = ref<BarEvent | null>(null)
const dialogue = ref('这么大的雨还来喝酒？……坐吧，窗边漏水。')
const dialogueTyping = ref(false)
const mobileMenuOpen = ref(false)
const stage = ref<'menu' | 'performing' | 'result' | 'failed'>('menu')
const appearance = ref<Appearance | null>(null)
const drinkDetail = ref<any>(null)
const drinkTrace = ref<any>(null)
const detailLoading = ref(false)
const collectPanelOpen = ref(false)
const collectLoading = ref(false)
const collectStatus = ref<CollectStatus | null>(null)
const collectResult = ref<CollectResult | null>(null)
const collectError = ref('')
const suppliesOpen = ref(false)
const suppliesLoading = ref(false)
const ingredients = ref<IngredientCatalogItem[]>([])
const backpack = ref<BackpackItem[]>([])
const maxExtras = ref(2)
const selectedExtras = ref<ExtraIngredient[]>([])
const extrasPickerOpen = ref(false)
const orderMessage = ref('听一听今晚的海。')
const suppliesError = ref('')
const suppliesNotice = ref('')
const submittingType = ref(0)
const environment = ref<IslandEnvironment | null>(null)
const viewerNow = ref(new Date())
let socket: WebSocket | null = null
let dialogueTimer: ReturnType<typeof setTimeout> | null = null
let dialogueTarget = dialogue.value
let serverClockOffset = 0
let clockTimer: ReturnType<typeof setInterval> | null = null
let environmentTimer: ReturnType<typeof setInterval> | null = null

function parseClockMinutes(value: string | undefined, fallback: number) {
  const match = /^(\d{2}):(\d{2})$/.exec(value || '')
  if (!match) return fallback
  return Number(match[1]) * 60 + Number(match[2])
}

const viewerMinutes = computed(() => viewerNow.value.getHours() * 60 + viewerNow.value.getMinutes())
const openMinutes = computed(() => parseClockMinutes(environment.value?.bar_business_hours?.open_time, 18 * 60))
const closeMinutes = computed(() => parseClockMinutes(environment.value?.bar_business_hours?.close_time, 2 * 60))
const barMode = computed<'open' | 'stocking' | 'closed'>(() => {
  const now = viewerMinutes.value
  const open = openMinutes.value
  const close = closeMinutes.value
  const isOpen = open > close ? now >= open || now < close : now >= open && now < close
  if (isOpen) return 'open'
  const stockingStarts = (open - 120 + 1440) % 1440
  const isStocking = stockingStarts < open
    ? now >= stockingStarts && now < open
    : now >= stockingStarts || now < open
  return isStocking ? 'stocking' : 'closed'
})
const bartenderPresent = computed(() => stage.value === 'performing' || stage.value === 'result' || barMode.value !== 'closed')
const localHour = computed(() => viewerNow.value.getHours() + viewerNow.value.getMinutes() / 60 + viewerNow.value.getSeconds() / 3600)
const currentWeather = computed(() => environment.value?.weather?.current || null)
const speakerName = computed(() => bartenderPresent.value ? '岛民娘' : '门边的木牌')
const venueStateLabel = computed(() => barMode.value === 'open' ? '营业中' : barMode.value === 'stocking' ? '备货中' : '休息中')
const orderActionLabel = computed(() => {
  if (barMode.value === 'stocking') return `备货中，${environment.value?.bar_business_hours?.open_time || '18:00'} 营业`
  if (barMode.value === 'closed') return `休息中，${environment.value?.bar_business_hours?.open_time || '18:00'} 再来`
  return token.value ? '请岛民娘调一杯' : '登录后点一杯'
})

function stopDialogueTyping(reveal = false) {
  if (dialogueTimer) clearTimeout(dialogueTimer)
  dialogueTimer = null
  dialogueTyping.value = false
  if (reveal) dialogue.value = dialogueTarget
}

function showDialogue(text: unknown, immediate = false) {
  const next = String(text || '')
  if (next === dialogueTarget && (dialogueTyping.value || dialogue.value === next)) return
  stopDialogueTyping()
  dialogueTarget = next
  const reduceMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches
  if (immediate || reduceMotion || !next) {
    dialogue.value = next
    return
  }

  const characters = Array.from(next)
  let index = 0
  dialogue.value = ''
  dialogueTyping.value = true
  const typeNext = () => {
    const character = characters[index++]
    dialogue.value += character
    if (index >= characters.length) {
      dialogueTyping.value = false
      dialogueTimer = null
      return
    }
    const delay = /[。！？!?…]/.test(character) ? 180 : /[，、；：,]/.test(character) ? 95 : 42
    dialogueTimer = setTimeout(typeNext, delay)
  }
  typeNext()
}

const selected = computed(() => recipes.value.find(item => item.id === selectedId.value) || null)
const catalogByType = computed(() => new Map(ingredients.value.map(item => [item.type_id, item])))
const backpackByType = computed(() => new Map(backpack.value.map(item => [item.type_id, item])))
const mixableIngredients = computed(() => ingredients.value.filter(item => item.extra_enabled))
const extrasValid = computed(() => selectedExtras.value.length <= maxExtras.value && selectedExtras.value.every(extra => {
  const catalog = catalogByType.value.get(extra.type_id)
  const available = extra.source === 'backpack' ? backpackByType.value.get(extra.type_id)?.quantity || 0 : catalog?.available_qty || 0
  return Boolean(catalog?.extra_enabled && extra.quantity > 0 && extra.quantity <= catalog.max_qty_per_drink && extra.quantity <= available)
}))
const canOrder = computed(() => barMode.value === 'open' && selected.value?.status === 'available' && stage.value !== 'performing' && extrasValid.value)
const colorByRecipe: Record<number, string> = {
  1: '#e68a4d', 2: '#0a9ed0', 3: '#57a66a', 4: '#e3a234', 5: '#a85c32',
}

async function loadMenu() {
  loading.value = true
  try {
    recipes.value = await fetchMenu()
    if (!recipes.value.some(item => item.id === selectedId.value)) selectedId.value = recipes.value[0]?.id || 1
  } catch (reason) {
    error.value = `今夜酒单暂时无法送达：${reason instanceof Error ? reason.message : reason}`
  } finally {
    loading.value = false
  }
}

async function loadEnvironment() {
  try {
    const result = await fetchIslandEnvironment()
    environment.value = result
    serverClockOffset = result.time?.server_time ? result.time.server_time * 1000 - Date.now() : 0
    localStorage.setItem('islander.environment', JSON.stringify(result))
  } catch (reason) {
    const cached = localStorage.getItem('islander.environment')
    if (cached && !environment.value) {
      try { environment.value = JSON.parse(cached) as IslandEnvironment } catch (_) { /* use calm fallback */ }
    }
    console.warn('island environment load failed', reason)
  } finally {
    viewerNow.value = new Date(Date.now() + serverClockOffset)
  }
}

function sceneGreeting(mode = barMode.value) {
  if (mode === 'open') {
    const weather = currentWeather.value?.condition_name
    return weather ? `今晚是${weather}。既然推门进来了，就坐下选一杯吧。` : '灯已经亮了。既然推门进来了，就坐下选一杯吧。'
  }
  if (mode === 'stocking') return '还没到营业时间。我在整理今晚的物料，你可以把行囊里的东西拿来看看。'
  return `海浪之歌将在 ${environment.value?.bar_business_hours?.open_time || '18:00'} 亮灯。门锁着，岛民娘现在不在店里。`
}

async function loadSupplies() {
  suppliesLoading.value = true
  suppliesError.value = ''
  try {
    const catalog = await fetchIngredients()
    ingredients.value = catalog.ingredients || []
    maxExtras.value = catalog.max_extras_per_drink
    if (token.value) backpack.value = await fetchBackpack(token.value)
    else backpack.value = []
  } catch (reason) {
    suppliesError.value = reason instanceof Error ? reason.message : '物品清单暂时送不过来'
  } finally {
    suppliesLoading.value = false
  }
}

function extraLimit(item: IngredientCatalogItem | BackpackItem, source: 'bar' | 'backpack') {
  const catalog = catalogByType.value.get(item.type_id)
  const available = source === 'bar' ? catalog?.available_qty || 0 : backpackByType.value.get(item.type_id)?.quantity || 0
  return Math.min(catalog?.max_qty_per_drink || 0, available)
}

function toggleExtra(item: IngredientCatalogItem | BackpackItem, source: 'bar' | 'backpack') {
  suppliesError.value = ''
  const index = selectedExtras.value.findIndex(extra => extra.type_id === item.type_id)
  if (index >= 0 && selectedExtras.value[index].source === source) {
    selectedExtras.value.splice(index, 1)
    return
  }
  const catalog = catalogByType.value.get(item.type_id)
  const quantity = Math.min(catalog?.suggested_qty || 1, extraLimit(item, source))
  if (!catalog?.extra_enabled || quantity <= 0) return
  const next = { type_id: item.type_id, quantity, source }
  if (index >= 0) selectedExtras.value.splice(index, 1, next)
  else if (selectedExtras.value.length < maxExtras.value) selectedExtras.value.push(next)
}

function selectedExtra(typeId: number) {
  return selectedExtras.value.find(item => item.type_id === typeId)
}

function selectedExtraSource(typeId: number): 'bar' | 'backpack' {
  return selectedExtra(typeId)?.source || 'bar'
}

function selectRecipe(recipe: Recipe) {
  if (selectedId.value !== recipe.id) {
    selectedExtras.value = []
    extrasPickerOpen.value = false
  }
  selectedId.value = recipe.id
  showDialogue(barMode.value === 'open' ? recipe.story : sceneGreeting())
}

function updateExtraQuantity(typeId: number, quantity: number) {
  const extra = selectedExtras.value.find(item => item.type_id === typeId)
  if (!extra) return
  const sourceItem = extra.source === 'bar' ? catalogByType.value.get(typeId) : backpackByType.value.get(typeId)
  if (!sourceItem) return
  extra.quantity = Math.max(0.01, Math.min(Math.round(quantity * 100) / 100, extraLimit(sourceItem, extra.source)))
}

function updateExtraFromEvent(typeId: number, event: Event) {
  updateExtraQuantity(typeId, Number((event.target as HTMLInputElement).value))
}

function removeExtra(typeId: number) {
  const index = selectedExtras.value.findIndex(item => item.type_id === typeId)
  if (index >= 0) selectedExtras.value.splice(index, 1)
}

async function submitItem(item: BackpackItem, quantity: number) {
  if (!token.value || submittingType.value || quantity <= 0 || quantity > item.quantity) return
  submittingType.value = item.type_id
  suppliesError.value = ''
  suppliesNotice.value = ''
  try {
    const result = await submitBackpackItem(token.value, item.type_id, Math.round(quantity * 100) / 100)
    suppliesNotice.value = `已把 ${result.quantity} ${result.unit} ${result.name}交给酒吧。`
    await loadSupplies()
  } catch (reason) {
    suppliesError.value = reason instanceof Error ? reason.message : '这件物品暂时无法上交'
  } finally {
    submittingType.value = 0
  }
}

async function loadCollectStatus() {
  if (!token.value) {
    collectStatus.value = null
    return
  }
  try {
    collectStatus.value = await fetchCollectStatus(token.value)
  } catch (reason) {
    collectError.value = reason instanceof Error ? reason.message : '暂时无法查看今日搜集次数'
  }
}

async function collectOnce() {
  if (!token.value || collectLoading.value || collectStatus.value?.remaining_today === 0) return
  collectLoading.value = true
  collectError.value = ''
  try {
    const result = await collectBarItem(token.value)
    collectResult.value = result
    collectStatus.value = result
    await loadSupplies()
  } catch (reason) {
    collectError.value = reason instanceof Error ? reason.message : '这次什么也没找到'
    if (reason instanceof BarApiError && reason.error === 'daily_collect_limit_reached') {
      collectStatus.value = {
        daily_limit: Number(reason.payload.daily_limit || 0),
        used_today: Number(reason.payload.used_today || 0),
        remaining_today: Number(reason.payload.remaining_today || 0),
        resets_at: Number(reason.payload.resets_at || 0),
      }
    }
  } finally {
    collectLoading.value = false
  }
}

function formatExpiry(seconds: number) {
  if (!seconds) return '长期保存'
  return new Date(seconds * 1000).toLocaleDateString(undefined, { month: 'short', day: 'numeric' })
}

function traceNotes(node: any): string[] {
  const current = node?.restock?.note ? [node.restock.note] : []
  return current.concat((node?.inputs || []).flatMap(traceNotes))
}

const flavorTags = computed(() => {
  const leaves = drinkDetail.value?.drink?.flavor_snapshot?.leaves || []
  return [...leaves].sort((a: any, b: any) => b.value - a.value).slice(0, 5)
})

const drinkExtras = computed(() => (drinkDetail.value?.drink?.inputs_snapshot || []).filter((item: any) => item.role === 'extra'))

function extraName(typeId: number) {
  return catalogByType.value.get(typeId)?.name || `物品 #${typeId}`
}

const sourceNotes = computed<string[]>(() => {
  const notes: string[] = (drinkTrace.value?.inputs || []).flatMap(traceNotes)
  return [...new Set<string>(notes.filter(Boolean))].slice(0, 4)
})

async function loadDrinkArchive(id: number, present = false) {
  detailLoading.value = true
  try {
    const [detail, trace] = await Promise.all([fetchDrink(id), fetchTrace(id)])
    drinkDetail.value = detail
    drinkTrace.value = trace
    if (present && detail?.drink) {
      selectedId.value = detail.drink.recipe_id
      appearance.value = detail.drink.appearance_snapshot
      showDialogue(detail.drink.description)
      stage.value = 'result'
      cue.value = { type: 'order.completed', payload: { drink: detail.drink, trace: trace.inputs || [] } }
    }
  } catch (reason) {
    console.warn('drink archive load failed', reason)
  } finally {
    detailLoading.value = false
  }
}

function receive(event: BarEvent) {
  const compatibilityLine = event.type === 'bartender.say' && ['ingredient', 'technique'].includes(event.payload.stage)
  if (!compatibilityLine) cue.value = { ...event, ts: event.ts || Date.now() }

  if (event.type === 'order.accepted') {
    stage.value = 'performing'
    showDialogue(`「${selected.value?.name}」？算你会挑。等着，别催。`)
  } else if (event.type === 'bartender.say') {
    showDialogue(event.payload.text)
  } else if (event.type === 'action.start' || event.type === 'action.technique') {
    showDialogue(event.payload.text)
  } else if (event.type === 'order.completed') {
    stage.value = 'result'
    appearance.value = event.payload.drink?.appearance_snapshot || event.payload.appearance_snapshot || appearance.value
    showDialogue(event.payload.drink?.description || event.payload.description || `好了，你的${selected.value?.name}。别洒了。`)
    const drinkId = Number(event.payload.drink?.id || 0)
    if (drinkId) void loadDrinkArchive(drinkId)
    void loadSupplies()
  } else if (event.type === 'order.failed') {
    stage.value = 'failed'
    showDialogue(event.payload.reason === 'unauthorized'
      ? '本地保存的登录信息已经失效，请重新同步岛民岛的饼干。'
      : `这杯暂时调不了：${event.payload.reason || '原料不够'}`)
  }
}

function startLiveOrder() {
  if (!selected.value || !token.value.trim() || !canOrder.value) return
  clearPerformance()
  stage.value = 'performing'
  showDialogue('正在把点单递给岛民娘……')
  mobileMenuOpen.value = false
  socket = createOrderSocket(
    token.value.trim(), selected.value.id, selectedExtras.value.map(extra => ({ ...extra })), orderMessage.value.trim(),
    receive, () => { socket = null },
  )
}

function clearPerformance() {
  socket?.close()
  socket = null
}

function backToMenu() {
  clearPerformance()
  stage.value = 'menu'
  cue.value = null
  appearance.value = null
  drinkDetail.value = null
  drinkTrace.value = null
  selectedExtras.value = []
  orderMessage.value = '听一听今晚的海。'
  showDialogue(selected.value?.story || '选一杯吧。')
}

onMounted(async () => {
  document.documentElement.classList.add('bar-route-active')
  await Promise.all([loadMenu(), loadCollectStatus(), loadSupplies(), loadEnvironment()])
  const archivedId = Number(new URLSearchParams(location.search).get('drink') || 0)
  if (archivedId > 0) void loadDrinkArchive(archivedId, true)
  else showDialogue(sceneGreeting())
  clockTimer = setInterval(() => { viewerNow.value = new Date(Date.now() + serverClockOffset) }, 30000)
  environmentTimer = setInterval(loadEnvironment, 5 * 60 * 1000)
  document.addEventListener('visibilitychange', refreshViewerClock)
})
function refreshViewerClock() {
  if (!document.hidden) viewerNow.value = new Date(Date.now() + serverClockOffset)
}
watch(barMode, (mode, previous) => {
  if (mode !== previous && stage.value === 'menu') showDialogue(sceneGreeting(mode))
})
onBeforeUnmount(() => {
  clearPerformance()
  stopDialogueTyping()
  if (clockTimer) clearInterval(clockTimer)
  if (environmentTimer) clearInterval(environmentTimer)
  document.removeEventListener('visibilitychange', refreshViewerClock)
  document.documentElement.classList.remove('bar-route-active')
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_router_link, {
          class: "header-action back-home",
          to: "/plate/0/page/1"
        }, {
          default: _withCtx(() => [
            _hoisted_6,
            _hoisted_7
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(BarSuppliesDrawer, {
      open: suppliesOpen.value,
      loading: suppliesLoading.value,
      ingredients: ingredients.value,
      backpack: backpack.value,
      error: suppliesError.value,
      notice: suppliesNotice.value,
      "submitting-type": submittingType.value,
      onClose: _cache[0] || (_cache[0] = ($event: any) => (suppliesOpen.value = false)),
      onRefresh: loadSupplies,
      onSubmit: submitItem
    }, null, 8, ["open", "loading", "ingredients", "backpack", "error", "notice", "submitting-type"]),
    (collectPanelOpen.value)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "collect-backdrop",
          type: "button",
          "aria-label": "关闭搜集面板",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (collectPanelOpen.value = false))
        }))
      : _createCommentVNode("", true),
    (collectPanelOpen.value)
      ? (_openBlock(), _createElementBlock("section", _hoisted_8, [
          _createElementVNode("button", {
            class: "collect-close",
            type: "button",
            "aria-label": "关闭搜集面板",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (collectPanelOpen.value = false))
          }, "×"),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _hoisted_11,
            (!_unref(token))
              ? (_openBlock(), _createElementBlock("p", _hoisted_12, "登录岛民岛后，今天可以出门搜集两次。"))
              : (collectStatus.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_13, [
                    _hoisted_14,
                    _createElementVNode("strong", null, _toDisplayString(collectStatus.value.remaining_today), 1),
                    _hoisted_15
                  ]))
                : (_openBlock(), _createElementBlock("p", _hoisted_16, "正在查看今天还能走多远……"))
          ]),
          (collectResult.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createElementVNode("span", null, _toDisplayString(collectResult.value.location.name), 1),
                _createElementVNode("strong", null, "你找到了 " + _toDisplayString(collectResult.value.item.name), 1),
                _createElementVNode("small", null, _toDisplayString(collectResult.value.item.quantity) + " " + _toDisplayString(collectResult.value.item.unit) + " · 保存至 " + _toDisplayString(formatExpiry(collectResult.value.item.expire_at)), 1)
              ]))
            : _createCommentVNode("", true),
          (collectError.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(collectError.value), 1))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            class: "collect-action",
            type: "button",
            disabled: !_unref(token) || collectLoading.value || !collectStatus.value || collectStatus.value.remaining_today === 0,
            onClick: collectOnce
          }, _toDisplayString(collectLoading.value ? '正在岛上寻找……' : collectStatus.value?.remaining_today === 0 ? '今天先休息吧' : '出门走一趟 →'), 9, _hoisted_19)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("button", {
      class: "mobile-menu-trigger",
      onClick: _cache[3] || (_cache[3] = ($event: any) => (mobileMenuOpen.value = true))
    }, [
      _hoisted_20,
      _createElementVNode("b", null, _toDisplayString(_unref(selected)?.name || '选一杯'), 1),
      _hoisted_21
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["drawer-backdrop", { open: mobileMenuOpen.value }]),
      onClick: _cache[4] || (_cache[4] = ($event: any) => (mobileMenuOpen.value = false))
    }, null, 2),
    _createElementVNode("section", _hoisted_22, [
      _createElementVNode("div", _hoisted_23, [
        _createVNode(PixelBarStage, {
          cue: cue.value,
          recipe: _unref(selected),
          appearance: appearance.value,
          "local-hour": _unref(localHour),
          weather: _unref(currentWeather),
          "bar-mode": _unref(barMode),
          "bartender-present": _unref(bartenderPresent)
        }, null, 8, ["cue", "recipe", "appearance", "local-hour", "weather", "bar-mode", "bartender-present"]),
        _createElementVNode("div", {
          class: _normalizeClass(["dialogue-box", [{ result: stage.value === 'result' }, `venue-${_unref(barMode)}`]])
        }, [
          _createElementVNode("div", _hoisted_24, [
            _hoisted_25,
            _createTextVNode(" " + _toDisplayString(_unref(speakerName)) + " ", 1),
            _createElementVNode("small", _hoisted_26, _toDisplayString(_unref(venueStateLabel)), 1)
          ]),
          _createElementVNode("p", null, [
            _createTextVNode(_toDisplayString(dialogue.value), 1),
            (dialogueTyping.value)
              ? (_openBlock(), _createElementBlock("i", _hoisted_27))
              : _createCommentVNode("", true)
          ]),
          (stage.value === 'result' || stage.value === 'failed')
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "text-button",
                onClick: backToMenu
              }, "回到酒单 ↗"))
            : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("nav", _hoisted_28, [
          _createElementVNode("button", {
            class: _normalizeClass(["player-action collect-player-action", { active: collectPanelOpen.value }]),
            type: "button",
            onClick: _cache[5] || (_cache[5] = ($event: any) => {suppliesOpen.value = false; collectPanelOpen.value = !collectPanelOpen.value})
          }, [
            _hoisted_29,
            (collectStatus.value)
              ? (_openBlock(), _createElementBlock("b", _hoisted_30, _toDisplayString(collectStatus.value.remaining_today) + "/" + _toDisplayString(collectStatus.value.daily_limit), 1))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("button", {
            class: _normalizeClass(["player-action supplies-player-action", { active: suppliesOpen.value }]),
            type: "button",
            onClick: _cache[6] || (_cache[6] = ($event: any) => {collectPanelOpen.value = false; suppliesOpen.value = true})
          }, [
            _hoisted_31,
            _createElementVNode("b", null, _toDisplayString(backpack.value.length), 1)
          ], 2)
        ]),
        (stage.value === 'result' && (drinkDetail.value || detailLoading.value))
          ? (_openBlock(), _createElementBlock("section", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("div", null, [
                  _hoisted_34,
                  _createElementVNode("h2", null, _toDisplayString(drinkDetail.value?.drink?.drink_name || '这一杯的档案'), 1)
                ]),
                (drinkDetail.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_35, "#" + _toDisplayString(drinkDetail.value.drink.id), 1))
                  : _createCommentVNode("", true)
              ]),
              (detailLoading.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_36, _hoisted_40))
                : (drinkDetail.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("div", _hoisted_41, [
                        _createElementVNode("div", null, [
                          _hoisted_42,
                          _createElementVNode("div", _hoisted_43, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(flavorTags), (flavor) => {
                              return (_openBlock(), _createElementBlock("span", {
                                key: flavor.id
                              }, [
                                _createTextVNode(_toDisplayString(flavor.name) + " ", 1),
                                _createElementVNode("b", null, _toDisplayString(flavor.value.toFixed(1)), 1)
                              ]))
                            }), 128)),
                            (!_unref(flavorTags).length)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_44, "等待风味数据"))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", null, [
                          _hoisted_45,
                          _createElementVNode("p", null, _toDisplayString((drinkDetail.value.drink.mouthfeel_snapshot?.dominant || []).join(' · ') || drinkDetail.value.drink.mouthfeel_snapshot?.texture || '—'), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_46, [
                        _hoisted_47,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sourceNotes), (note) => {
                          return (_openBlock(), _createElementBlock("span", { key: note }, _toDisplayString(note), 1))
                        }), 128)),
                        (!_unref(sourceNotes).length)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_48, "这杯酒用了 " + _toDisplayString(drinkTrace.value?.inputs?.length || 0) + " 项原料", 1))
                          : _createCommentVNode("", true)
                      ]),
                      (_unref(drinkExtras).length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                            _hoisted_50,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(drinkExtras), (item) => {
                              return (_openBlock(), _createElementBlock("span", {
                                key: item.type_id
                              }, [
                                _createTextVNode(_toDisplayString(item.name || extraName(item.type_id)) + " · " + _toDisplayString(item.qty) + " ", 1),
                                _createElementVNode("b", null, _toDisplayString(item.portions?.some((portion) => portion.inventory === 'backpack') ? '来自行囊' : '酒吧库存'), 1)
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("aside", {
        class: _normalizeClass(["menu-panel", { 'mobile-open': mobileMenuOpen.value }]),
        "aria-label": "今夜酒单抽屉"
      }, [
        _createElementVNode("div", _hoisted_51, [
          _hoisted_52,
          _createElementVNode("div", _hoisted_53, [
            _createElementVNode("button", {
              class: "refresh",
              disabled: loading.value,
              onClick: loadMenu,
              title: "刷新酒单"
            }, "↻", 8, _hoisted_54),
            _createElementVNode("button", {
              class: "drawer-close",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (mobileMenuOpen.value = false)),
              "aria-label": "收起酒单"
            }, "↓")
          ])
        ]),
        (error.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_55, _toDisplayString(error.value), 1))
          : _createCommentVNode("", true),
        (loading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_56, _hoisted_60))
          : (_openBlock(), _createElementBlock("div", _hoisted_61, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(recipes.value, (recipe) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: recipe.id,
                  class: _normalizeClass(["recipe-card", { active: recipe.id === selectedId.value, unavailable: recipe.status !== 'available' }]),
                  onClick: ($event: any) => (selectRecipe(recipe))
                }, [
                  _createElementVNode("span", {
                    class: "drink-swatch",
                    style: _normalizeStyle({ '--drink': colorByRecipe[recipe.id] })
                  }, null, 4),
                  _createElementVNode("span", _hoisted_63, [
                    _createElementVNode("strong", null, _toDisplayString(recipe.name), 1),
                    _createElementVNode("small", null, _toDisplayString(recipe.technique) + " · 今夜第 " + _toDisplayString(recipe.order_count + 1) + " 杯", 1)
                  ]),
                  _hoisted_64
                ], 10, _hoisted_62))
              }), 128))
            ])),
        (_unref(selected))
          ? (_openBlock(), _createElementBlock("article", _hoisted_65, [
              _createElementVNode("div", _hoisted_66, [
                _createElementVNode("span", null, "NO. 0" + _toDisplayString(_unref(selected).id), 1),
                _createElementVNode("span", null, _toDisplayString(_unref(barMode) === 'open' ? _unref(selected).status === 'available' ? '可调制' : '今日无货' : _unref(venueStateLabel)), 1)
              ]),
              _createElementVNode("h3", null, _toDisplayString(_unref(selected).name), 1),
              _createElementVNode("p", null, _toDisplayString(_unref(selected).story), 1),
              _createElementVNode("div", _hoisted_67, [
                _hoisted_68,
                _createElementVNode("b", null, _toDisplayString(_unref(selected).technique), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("section", _hoisted_69, [
          _createElementVNode("div", _hoisted_70, [
            _hoisted_71,
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass({ active: extrasPickerOpen.value }),
              onClick: _cache[8] || (_cache[8] = ($event: any) => (extrasPickerOpen.value = !extrasPickerOpen.value))
            }, _toDisplayString(extrasPickerOpen.value ? '收起' : '选择') + " " + _toDisplayString(selectedExtras.value.length) + "/" + _toDisplayString(maxExtras.value) + " " + _toDisplayString(extrasPickerOpen.value ? '↑' : '↓'), 3)
          ]),
          (extrasPickerOpen.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(mixableIngredients), (item) => {
                  return (_openBlock(), _createElementBlock("article", {
                    key: item.type_id,
                    class: _normalizeClass({ chosen: selectedExtra(item.type_id) })
                  }, [
                    _createElementVNode("div", _hoisted_73, [
                      _createElementVNode("strong", null, _toDisplayString(item.name), 1),
                      _createElementVNode("small", null, "建议 " + _toDisplayString(item.suggested_qty) + " " + _toDisplayString(item.unit) + " · 上限 " + _toDisplayString(item.max_qty_per_drink), 1)
                    ]),
                    _createElementVNode("div", _hoisted_74, [
                      _createElementVNode("button", {
                        type: "button",
                        class: _normalizeClass({ active: selectedExtra(item.type_id)?.source === 'bar' }),
                        disabled: !item.available || (!selectedExtra(item.type_id) && selectedExtras.value.length >= maxExtras.value),
                        onClick: ($event: any) => (toggleExtra(item, 'bar'))
                      }, "酒吧 " + _toDisplayString(item.available_qty), 11, _hoisted_75),
                      _createElementVNode("button", {
                        type: "button",
                        class: _normalizeClass({ active: selectedExtra(item.type_id)?.source === 'backpack' }),
                        disabled: !_unref(backpackByType).get(item.type_id)?.quantity || (!selectedExtra(item.type_id) && selectedExtras.value.length >= maxExtras.value),
                        onClick: ($event: any) => (toggleExtra(item, 'backpack'))
                      }, "行囊 " + _toDisplayString(_unref(backpackByType).get(item.type_id)?.quantity || 0), 11, _hoisted_76)
                    ]),
                    (selectedExtra(item.type_id))
                      ? (_openBlock(), _createElementBlock("label", _hoisted_77, [
                          _hoisted_78,
                          _createElementVNode("input", {
                            value: selectedExtra(item.type_id)?.quantity,
                            type: "number",
                            min: "0.01",
                            max: extraLimit(item, selectedExtraSource(item.type_id)),
                            step: "0.01",
                            onInput: ($event: any) => (updateExtraFromEvent(item.type_id, $event))
                          }, null, 40, _hoisted_79),
                          _createElementVNode("b", null, _toDisplayString(item.unit), 1),
                          _createElementVNode("button", {
                            type: "button",
                            onClick: ($event: any) => (removeExtra(item.type_id))
                          }, "×", 8, _hoisted_80)
                        ]))
                      : _createCommentVNode("", true)
                  ], 2))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (selectedExtras.value.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedExtras.value, (extra) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: extra.type_id,
                    type: "button",
                    onClick: ($event: any) => (removeExtra(extra.type_id))
                  }, [
                    _createTextVNode(_toDisplayString(extraName(extra.type_id)) + " " + _toDisplayString(extra.quantity) + _toDisplayString(_unref(catalogByType).get(extra.type_id)?.unit) + " ", 1),
                    _createElementVNode("small", null, _toDisplayString(extra.source === 'backpack' ? '行囊' : '酒吧'), 1),
                    _hoisted_83
                  ], 8, _hoisted_82))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("p", _hoisted_84, "不加也可以，原配方会保持原来的名字。")),
          _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((orderMessage).value = $event)),
            maxlength: "80",
            placeholder: "给岛民娘留一句话……"
          }, null, 512), [
            [
              _vModelText,
              orderMessage.value,
              void 0,
              { trim: true }
            ]
          ])
        ]),
        _createElementVNode("div", _hoisted_85, [
          _createElementVNode("button", {
            class: "primary-action",
            disabled: !_unref(canOrder) || !_unref(token).trim(),
            onClick: startLiveOrder
          }, [
            _createElementVNode("span", null, _toDisplayString(_unref(orderActionLabel)), 1)
          ], 8, _hoisted_86)
        ])
      ], 2)
    ])
  ]))
}
}

})